import { render } from "./Services.vue?vue&type=template&id=6a4589de&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=6a4589de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a4589de"

export default script